import React, { Component } from 'react'
import { COLORS } from '../pages/theme';
import { MoreHoriz, Equalizer, PlaylistAddCheckOutlined, QueueOutlined } from '@material-ui/icons';
import { ScoredTag, TransparentButton, IconButton } from './basic_items';
import { formatMoney } from '../lib/util';
import { CustomStatsSmall } from './custom_stat';
import { Tag, Divider, Collapse, Descriptions, Tooltip, Row, Col, Checkbox } from 'antd';
import Paragraph from 'antd/lib/typography/Paragraph';


class TransactionBatchIndividualItem extends Component {

    state={
        expanded:false,
    }
    render() {
        let data = this.props.data || {};
        let selectedID = this.props.selectedID;
        let itemID = this.props.itemID;
        let isSelectable=this.props.isSelectable;
        let batch_mode=this.props.batch_mode||'Manual';
        let  selected_left=this.props.selected_left;
        let side=this.props.side;
        let selected_right_txn_for_batch=this.props.selected_right_txn_for_batch??[];
        let onSelect=this.props.onSelect;

        const  {expanded}=this.state;

        return (
            <div
            className={''}
                style={{
                    background: COLORS.white,
                    border: `1px solid ${expanded?COLORS.success_primary:COLORS.border_basic}`,
                    boxShadow: `0px 0px 10px rgba(0, 0, 0, 0.15)`,
                    borderRadius: 5,
                    overflow:'hidden',
                    // opacity:other_selected?0.4:1,
                    // maxHeight:600,
                    // overflowY:'scroll'
                }}>
                <div style={{
                    paddingLeft: 16, paddingRight: 16,
                    paddingTop: 8,
                    paddingBottom: 8
                }}>
                      <div style={{
                    gap:16,
                    display:'flex',
                    alignItems:'center'
                }}>
                <Checkbox 
                checked={selected_right_txn_for_batch.includes(itemID)}
                onChange={()=>{
                    onSelect(itemID)
                }}
                />
                <div style={{
                    flex:1
                }} 
                className='hand-cursor'
                onClick={()=>{
                this.setState({
                    expanded:true
                })
            }}>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        flexWrap: 'nowrap',

                    }}>
                        <div style={{marginRight:12}}>
                        <div 
                        title={data.type == 'C' ? "Credit" : (data.type == 'D' ? "Debit" : "N/A")} 
                        className={data.type === 'D' ? 'debit-circle' : data.type == 'C' ? 'credit-circle' : 'na-circle'}
                        style={{
                            height:34,
                            width:34,
                            borderRadius:18
                        }}
                        >
                            {data.type}
                        </div>
                        </div>
                        <div style={{flex:1}}>
                        <div className='heading-2'>{data.txn_date}</div>
                        </div>
                        <div style={{flex:1}}>
                        <div className='heading-2'>{data.transaction_id}</div>
                        </div>
                        <div style={{flex:1,
                        textAlign:'right'
                        }}>
                        <div className='heading-2' style={{
                            color: COLORS.primary
                        }}>{formatMoney(data.amount)}</div>
                        </div>
                    </div>

                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        flexWrap: 'nowrap',
                        marginTop: 8
                    }}>
                        <span className='sub-heading-3 word-break' style={{
                            color: COLORS.secondary
                        }}>
                            {data.description}
                        </span>
                        {/* <span className='hand-cursor' style={{marginLeft:8}}> */}
                        {/* <MoreHoriz
                            className='hand-cursor main-icon' style={{ marginLeft: 8 }}
                            titleAccess="Detail"
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                typeof this.props.onViewDetailClicked === 'function' && this.props.onViewDetailClicked(itemID)
                            }}
                        /> */}
                        {/* </span> */}
                    </div>
                    </div>
                    </div>
                </div>
                {this.props.isRuleSelector&&<div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        // justifyContent: 'space-between',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        // marginTop:8,
                        // paddingTop:8,
                        borderTop: `1px solid ${COLORS.border_basic}`,
                        paddingLeft: 16,
                        paddingRight:16,
                        paddingTop:12,paddingBottom:12
                    }}>
                         {Array.isArray(data.rules)&&data.rules.map((rule)=>{
                        return <Tooltip title={rule.rule_name} ><Tag
                        style={{margin:2}}
                        color={(itemID && selectedID && (itemID === selectedID)&&(rule.rule_id==this.props.selectedRule))?COLORS.primary:null}
                        onClick={(e)=>{
                            e.preventDefault();
                            e.stopPropagation();
                            if(itemID && selectedID && (itemID === selectedID)&&(rule.rule_id==this.props.selectedRule)){
                                typeof this.props.onRuleSelected==='function'&&this.props.onRuleSelected(data.id,data,{});
                            }else{
                            typeof this.props.onRuleSelected==='function'&&this.props.onRuleSelected(data.id,data,rule);
                            }
                        }}
                        className='hand-cursor'
                    >{rule.rule_name}</Tag></Tooltip>
                    })
                    }
                </div>}
                {Array.isArray(data.individual_scores) &&
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        flexWrap: 'nowrap',
                        // marginTop:8,
                        // paddingTop:8,
                        borderTop: `1px solid ${COLORS.border_basic}`,
                        paddingLeft: 16,
                        paddingRight:16
                    }}>
                        {/* <Equalizer style={{ marginRight: 12 }} className='main-icon' /> */}
                        <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            flexWrap: 'wrap',
                            flex: 1,
                            paddingTop: 6, paddingBottom: 6
                        }}>
                            {data.individual_scores.map((item)=>{
                        return <ScoredTag 
                        valuekey={item.key}
                        value={item.value}
                        score={item.score}
                        />
                    })}
                            {/* {Array(10).fill("0").map((item) => {
                                return <ScoredTag valuekey="amount" value="1587008"
                                    score={0.3}
                                />
                            })} */}

                        </div>
                        <div style={{
                            // width: 190,
                            // backgroundColor: COLORS.success_primary,
                            paddingTop: 4, paddingBottom: 4, paddingLeft: 8,
                            // paddingRight: 8,
                            textAlign: 'center',
                            alignSelf: 'stretch',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}>
                            <span className='heading-1' style={{
                                color: COLORS.success_primary
                            }}>{(data.score*100).toLocaleString()}%</span>
                        </div>
                    </div>
                }
                {
                    expanded&&
                    <React.Fragment>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        // alignItems: 'center',
                        flexWrap: 'nowrap',
                        // marginTop:8,
                        // paddingTop:8,
                        borderTop: `1px solid ${COLORS.border_basic}`,
                        paddingLeft: 16,
                        paddingRight:16,
                    }}>
                        <Row type='flex' style={{
                            // display:'flex',
                            // flexDirection:'row',
                            width:'70%',
                            // flexWrap:'wrap',
                            // justifyContent:'space-between',
                            paddingTop:16,
                            paddingBottom:16,
                        }}>
                            <Col span={12}>
                            <CustomStatsSmall
                            label="DATATYPE"
                            title={data.data_type_name||"N/A"}
                            style={{
                                marginBottom:6,
                                
                            }}
                            titleStyle={{
                                fontSize:12
                            }}
                             />
                            </Col>
                            <Col span={12}>
                            <CustomStatsSmall
                            label="SOURCE LABEL"
                            title={data.source_label||"N/A"}
                            style={{
                                marginBottom:6,
                                marginLeft:12
                            }}
                            titleStyle={{
                                fontSize:12
                            }}
                             />
                            </Col>
                            <Col span={12}>
                            <CustomStatsSmall
                            label="SERVICE TYPE"
                            title={data.service_name||"N/A"}
                            style={{
                                marginBottom:6
                            }}
                            titleStyle={{
                                fontSize:12
                            }}
                             />
                            </Col>
                            <Col span={12}>
                            <CustomStatsSmall
                            label="SOURCE ID"
                            title={data.source_id||"N/A"}
                            style={{
                                marginBottom:6,
                                marginLeft:12
                            }}
                            titleStyle={{
                                fontSize:12
                            }}
                             />
                            </Col>
                        </Row>
                        {/* <div style={{
                            display:'flex',
                            flexDirection:'row',
                            width:'70%',
                            flexWrap:'wrap',
                            justifyContent:'space-between',
                            paddingTop:16,
                            paddingBottom:16,
                        }}>
                           
                           
                            
                            
                        </div>
                         */}
                        <div style={{
                            display:'flex',
                            flexDirection:'row',
                            width:'25%',
                            flexWrap:'wrap',
                            borderLeft: `1px solid ${COLORS.border_basic}`,
                            paddingTop:16,
                            paddingBottom:16,
                            paddingLeft:8
                        }}>
                            {Array.isArray(data.flags)&&data.flags.length>0?data.flags.map((item)=>{
                                return <div style={{
                                    maxWidth:'100%',
                                    height:'fit-content',
                                    marginBottom:2
                                }}><Tag title="FRAUD" className='tag-orange' style={{ marginRight: 6 }}>{item}</Tag></div>
                            }):<span style={{opacity:0.5,}} className='sub-heading-4'>No Labels Added</span>}
                           
                        </div>
                    </div>
                    {/* <Divider style={{marginTop:0,marginBottom:12}}/> */}
                    <div style={{
                        display:'flex',
                        flexDirection:'row',
                        // paddingLeft:16,
                        // paddingRight:16,
                        width:'100%',
                        paddingTop:0,
                        borderTop:`1px solid ${COLORS.border_basic}`,
                        borderBottom:`1px solid ${COLORS.border_basic}`,
                        paddingBottom:0
                    }}>
                    <Collapse style={{
                        width:'100%',
                    }} className='customCollapse' accordion bordered={false} expandIconPosition='right'>
                                        <Collapse.Panel header={<span className='sub-heading-3' style={{
                                            fontSize:12
                                        }}>PARSED DATA</span>} key="1">
                                        {data.parsed_data && Object.keys(data.parsed_data).length > 0 &&
                                        <Descriptions bordered column={1} className='smallPaddingWhiteDescription'  size='small' layout='horizontal'>
                                            {Object.keys(data.parsed_data).map((key) => {
                                                if (!key.startsWith('__')) {
                                                    return <Descriptions.Item key={key} label={key} className='log-text' >
                                                        <Paragraph  style={{marginBottom:0}}>
                                                            {typeof data.parsed_data[key] === 'string' ? data.parsed_data[key] : JSON.stringify(data.parsed_data[key])}
                                                        </Paragraph>
                                                    </Descriptions.Item>

                                                }
                                            })}
                                        </Descriptions>
                                    }
                                        </Collapse.Panel>
                                        </Collapse>
                    </div>
                   
                    <div style={{
                        display:'flex',
                        flexDirection:'row',
                        justifyContent:'space-between',
                        paddingLeft:16,
                        paddingRight:16,
                        width:'100%',
                        paddingTop:12,
                        // borderTop:`1px solid ${COLORS.border_basic}`,
                        // borderBottom:`1px solid ${COLORS.border_basic}`,
                        paddingBottom:12,
                        alignItems:'center'
                    }}>
                    
                    <a className='sub-heading-4' style={{
                        color:COLORS.primary
                    }}
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        typeof this.props.onViewDetailClicked === 'function' && this.props.onViewDetailClicked(itemID)
                    }}
                    >VIEW DETAIL</a>
                    
                    {this.props.reconcile_btn}
                    
                    {false&&
                    <IconButton
                    label="CREATE BATCH"
                    style={{
                        color:COLORS.success_primary
                    }}
                    icon={<QueueOutlined/>}
                    onClick={(e)=>{
                        e.stopPropagation();
                        e.preventDefault();
                        typeof this.props.onCreateBatch==='function'&&this.props.onCreateBatch(itemID,data);
                    }}
                    />}
                    {false&&<React.Fragment>
                    <IconButton
                    label="ADD TO BATCH"
                    style={{
                        color:COLORS.success_primary
                    }}
                    icon={<QueueOutlined/>}
                    onClick={(e)=>{
                        e.stopPropagation();
                        e.preventDefault();
                        typeof this.props.onAddToBatch==='function'&&this.props.onAddToBatch(itemID,{add:true})
                    }}
                    />
                     <IconButton
                    label="DEDUCT TO BATCH"
                    style={{
                        // color:COLORS.success_primary
                    }}
                    icon={<QueueOutlined/>}
                    onClick={(e)=>{
                        e.stopPropagation();
                        e.preventDefault();
                        typeof this.props.onAddToBatch==='function'&&this.props.onAddToBatch(itemID,{add:false})
                    }}
                    />
                        </React.Fragment>}

                    <a className='sub-heading-4' 
                    onClick={()=>{
                        this.setState({
                            expanded:false
                        })
                    }}
                    style={{
                        color:COLORS.danger_primary,
                        opacity:1,
                    }}
                    >CLOSE</a>
                    </div>
                    </React.Fragment>
                }
            </div>
        )
    }
}

export default TransactionBatchIndividualItem
